import { BidStatus, BidStatusName } from '../types/auction';

// Updates bidding context for upcoming vehicle
export const updateBidContextWithUpcomingProxy = (context, auctionSummary) => ({
  ...context,
  auctionSummary: {
    ...context.auctionSummary,
    ...auctionSummary
  },
  currentProxyAmount:
    auctionSummary?.upcomingProxyAmount ??
    context?.currentUpcomingProxy?.proxyAmount,
  currentUpcomingProxy: {
    proxyAmount:
      auctionSummary?.upcomingProxyAmount ??
      context?.currentUpcomingProxy?.proxyAmount,
    bidAmount:
      auctionSummary?.upcomingBidAmount ??
      context?.currentUpcomingProxy?.bidAmount
  }
});

// Updates bidding context for active vehicle
export const updateBidContextWithActiveBid = (context, auctionSummary) => {
  const hasUpdatedProxy =
    auctionSummary?.proxyAmount !== context?.currentProxyAmount;
  const hasUpdatedBidCount = auctionSummary?.numBids > context?.numberOfBids;
  const hasUpdatedBiddingDealerId =
    auctionSummary?.biddingDealerId !==
    context?.auctionSummary?.biddingDealerId;

  if (!(hasUpdatedBidCount || hasUpdatedProxy || hasUpdatedBiddingDealerId)) {
    return context;
  }

  const getBidStatus = (): BidStatus => {
    if (
      [BidStatus.topBidder, BidStatus.proxy].includes(
        auctionSummary?.userBidStatus
      )
    ) {
      return BidStatus.topBidder;
    }
    if (auctionSummary?.userBidStatus === BidStatus.outbid) {
      return BidStatus.outbid;
    }
    return auctionSummary?.userBidStatus;
  };
  const bidStatus = getBidStatus();

  const proxyAmount = auctionSummary?.proxyAmount;

  return {
    ...context,
    auctionSummary: {
      ...context.auctionSummary,
      ...auctionSummary,
      proxyAmount,
      minBidThreshold: context?.auctionSummary?.minBidThreshold,
      userBidStatus: bidStatus
    },
    bidStatus,
    currentBidAmount: auctionSummary.maxBid,
    currentProxyAmount: proxyAmount,
    proxyAmount,
    numberOfBids: auctionSummary?.numBids,
    variant: BidStatusName[bidStatus],
    ...(auctionSummary?.isTimerExtended && { isTimerExtended: true }),
    activeExpiryTime: auctionSummary?.activeExpiryTime,
    ...(auctionSummary?.tradeFloorPrice && {
      tradeFloorPrice: auctionSummary?.tradeFloorPrice
    }),
    isSettingProxy: !!proxyAmount
  };
};

// Updates bid context with auction summary object which is received from one of
//   - bid place API response
//   - trade details API response
//   - biddingData (omp only, to communicate with search)
const updateBidContextWithAuctionSummary = (setBidContext, auctionSummary) => {
  setBidContext(context => {
    if (context?.currentUpcomingProxy?.proxyAmount) {
      return updateBidContextWithUpcomingProxy(context, auctionSummary);
    }
    return updateBidContextWithActiveBid(context, auctionSummary);
  });
};

export default updateBidContextWithAuctionSummary;
